export const COHORT_OPTIONS = [
  { value: "2026-cohort-1", label: "2026 Cohort 1" },
  { value: "2026-cohort-2", label: "2026 Cohort 2" },
  { value: "2026-cohort-3", label: "2026 Cohort 3" },
  { value: "2026-cohort-4", label: "2026 Cohort 4" },
  { value: "2026-kaduna-cohort-1", label: "2026 Kaduna Cohort 1" },
  { value: "2026-kaduna-cohort-2", label: "2026 Kaduna Cohort 2" },
  { value: "2026-kaduna-cohort-3", label: "2026 Kaduna Cohort 3" },
  { value: "2026-cohort-5", label: "2026 Cohort 5" },
  { value: "2026-cohort-6", label: "2026 Cohort 6" }
  
];

/** Cohort tag stored on Year 1 ISSAM participants (matches register-user-backend scripts). */
export const ISSAM_YEAR1_COHORT_TAG = "2025-cohort-1";

/**
 * Registered users page: filter by ISSAM intake year vs all other cohort tags.
 * value "" = no ISSAM year filter (use "All Cohorts" or TCP cohort dropdown only).
 */
export const ISSAM_COHORT_YEAR_FILTER_OPTIONS = [
  { value: "1", label: "ISSAM Year 1" },
  { value: "2", label: "ISSAM Year 2" },
];

export const LATEST_COHORT_VALUE =
  COHORT_OPTIONS[COHORT_OPTIONS.length - 1]?.value || "";

